// Validação de E-mail
export const emailRule = (value) => {
    if (!value) return 'E-mail é obrigatório.';
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(value) || 'E-mail inválido.';
  };
  
  // Validação de Campo Obrigatório
  export const requiredRule = (value) => {
    return !!value || 'Campo obrigatório.';
  };
  
  // Validação de Mínimo de Caracteres
  export const minLengthRule = (min) => (value) => {
    if (!value) return true; // Não valida se vazio, use requiredRule para isso
    return value.length >= min || `Mínimo de ${min} caracteres.`;
  };
  
  // Validação de Máximo de Caracteres
  export const maxLengthRule = (max) => (value) => {
    if (!value) return true;
    return value.length <= max || `Máximo de ${max} caracteres.`;
  };
  
  // Validação de Senha (exemplo: mínimo 8 caracteres, pelo menos 1 número e 1 letra)
  export const passwordRule = (value) => {
    if (!value) return 'Senha é obrigatória.';
    if (value.length < 8) return 'Mínimo de 8 caracteres.';
    if (!/[0-9]/.test(value)) return 'Pelo menos um número.';
    if (!/[a-zA-Z]/.test(value)) return 'Pelo menos uma letra.';
    return true;
  };
  
  // Validação de Confirmação de Senha (recebe a senha original como parâmetro)
  export const confirmPasswordRule = (originalPassword) => (value) => {
    return value === originalPassword || 'As senhas não coincidem.';
  };
  
  // Validação de Número (apenas dígitos)
  export const numberRule = (value) => {
    if (!value) return true;
    return /^\d+$/.test(value) || 'Apenas números são permitidos.';
  };
  
  // Validação de URL
  export const urlRule = (value) => {
    if (!value) return true;
    try {
      new URL(value);
      return true;
    } catch (e) {
      return 'URL inválida.';
    }
  };